<template>
    <div class="order-actions text-right mb-2 mr-2">
        <!-- Advertiser Actions -->
        <template v-if="_isAdvertiser">
            <div v-if="order.advertiser_action_required" class="mt-2 alert alert-info">Creative changes were requested. Please review and submit your changes.</div>

            <button v-if="order.can && order.can.submit_changes" class="btn btn-success" @click="confirmAction('submit_changes', 'Submit creative changes?')">
                Submit Creative Changes
            </button>
        </template>

        <!-- Admin/Team Actions -->
        <template v-else>
            <!-- Status Alert Messages -->
            <div v-if="_isAdmin && hasStatus('admin_change_requested')" class="d-flex alert alert-info">Creative change request was sent.</div>

            <div v-else-if="(_isTeam || _isAdmin) && hasStatus('team_change_requested')" class="d-flex alert alert-info">Creative change request was sent.</div>

            <div v-else-if="_isAdmin && hasStatus('admin_approved')" class="d-flex alert alert-info">Order was sent to team for approval.</div>

            <!-- Action Buttons (only show when not in change requested/approved states) -->
            <template v-else>
                <!-- Complete Verification -->
                <button v-if="order.can && order.can.set_verified" class="btn btn-success" @click="updateStatus('verified')">Complete Verification</button>

                <!-- Send to Team (Admin) -->
                <button
                    v-if="order.can && order.can.set_admin_approved"
                    class="btn btn-success"
                    @click="confirmAction('admin_approved', 'Send order to team?', 'This cannot be undone.')"
                >
                    Send to Team
                </button>

                <!-- Move to Active (Team) -->
                <button
                    v-if="order.can && order.can.set_team_approved"
                    class="btn btn-success"
                    @click="confirmAction('team_approved', 'Move order to active?', 'This cannot be undone.')"
                >
                    Move to Active
                </button>

                <!-- Deny Order (Admin) -->
                <button v-if="order.can && order.can.set_admin_denied" class="btn btn-light" @click="updateStatus('admin_denied')">Deny Order</button>

                <!-- Deny Order (Team) -->
                <button v-if="order.can && order.can.set_team_denied" class="btn btn-light" @click="updateStatus('team_denied')">Deny Order</button>

                <!-- Submit Change Requests (Admin) -->
                <button v-if="order.can && order.can.set_admin_change_requested" class="btn btn-info" @click="confirmAction('admin_change_requested', 'Submit change requests?')">
                    Submit Change Requests
                </button>

                <!-- Submit Change Requests (Team) -->
                <button v-if="order.can && order.can.set_team_change_requested" class="btn btn-info" @click="confirmAction('team_change_requested', 'Submit change requests?')">
                    Submit Change Requests
                </button>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'OrderStatusActions',

    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    computed: {
        hasAnyAction() {
            if (!this.order.can) return false;

            if (this._isAdvertiser) {
                return this.order.can.submit_changes;
            }

            return (
                this.order.can.set_verified ||
                this.order.can.set_admin_approved ||
                this.order.can.set_team_approved ||
                this.order.can.set_admin_denied ||
                this.order.can.set_team_denied ||
                this.order.can.set_admin_change_requested ||
                this.order.can.set_team_change_requested
            );
        },
    },

    methods: {
        hasStatus(statusName) {
            console.log(this.order.status);
            if (!this.order.status) return false;
            return this.order.status.includes(statusName);
        },

        updateStatus(status) {
            this.$emit('update-order-status', status);
        },

        confirmAction(status, message, submessage = null) {
            swalc(
                [message, submessage],
                confirmed => {
                    if (confirmed) {
                        this.updateStatus(status);
                    }
                },
                {
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes',
                },
            );
        },
    },
};
</script>
